<template>
  <div>
    <div v-if="selectedStep === 1 && currentPhase === 'prepare'" class="d-flex justify-content-between w-100">
      <a class="text-blue-main-toeic font-bold text-xl pointer" :class="{ 'opacity-0': isLocked }" @click="prevQuestion()">&lt; Back</a>
      <p class="font-bold text-xl">Part{{ currentPart + 1 }} Question {{ currentQuestionIndex + 1 }} of {{ currentPartQuestions.Questions.length }}</p>
      <a class="text-blue-main-toeic font-bold text-xl pointer" v-if="(currentQuestionIndex + 1 !== currentPartQuestions.Questions.length)" @click="nextQuestion()">Next &gt;</a>
      <a class="text-blue-main-toeic font-bold text-xl pointer" v-if="(currentQuestionIndex + 1 === currentPartQuestions.Questions.length)" @click="nextPart()">Next Part &gt;</a>
    </div>

    <div class="bg-white w-100 h-100 speaking_inner mb-2 mb-3">
      <Precautions v-if="selectedStep === 0" class="p-4" />

      <div v-if="selectedStep === 1" class="w-100 h-100">
        <div v-if="currentPhase === 'direction'" class="w-100 h-100 max-w-3xl mx-auto p-4">
          <p class="text-2xl font-bold text-center mb-4">{{ writingData[currentPart]?.NameEn }}</p>
          <p class="text-lg text-left" v-html="currentPartQuestions.Description.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></p>
          <div class="row text-lg" v-if="currentPart === 0">
            <div class="col-4">
              <p class="bg-blue-lighter2-toeic text-blue-main-toeic border-blue-main-toeic border p-1 font-semibold">Exmaple</p>
              <div class="w-100">
                <img src="@/assets/image/toeic/toeic_exam/example.png" alt="" class="object-contain w-100">
              </div>
              <p>men / fight</p>
            </div>
            <div class="col-8">
              <p class="bg-blue-lighter2-toeic text-blue-main-toeic border-blue-main-toeic border p-1 font-semibold">Sample response</p>
              <textarea id="sample" class="w-100 bg-white p-2" rows="5" disabled>Two men fight kendo on the rooftop to regain their dignity.</textarea>
            </div>
          </div>
        </div>
        <div v-if="currentPhase === 'prepare'">
          <div v-if="currentPart === 0">
            <Part1 :question="part1Questions.Questions[currentQuestionIndex]"
                  :index="currentQuestionIndex"
                  :total="part1Questions.Questions.length"
                  :SubDirection="currentPartQuestions.SubDirection"
                  :answer.sync="answerMap['1-' + currentQuestionIndex]"
                  @prev="prevQuestion"
                  @next="nextQuestion"
            />
          </div>

          <div v-if="currentPart === 1">
            <Part2 :question="part2Questions.Questions[currentQuestionIndex]"
                :answer.sync="answerMap['2-' + currentQuestionIndex]"
                @submit="goToNextPart2Question"
                :SubDirection="currentPartQuestions.SubDirection"
            />
          </div>

          <div v-if="currentPart === 2">
            <Part3 :question="part3Questions.Questions[currentQuestionIndex]"
                :answer.sync="answerMap['3-0']"
                @submit="submitAllAnswers"
                :SubDirection="currentPartQuestions.SubDirection"
            />
          </div>
          <!-- <p class="max-w-3xl mx-auto text-lg text-left">Good evening, this is the National Weather Bureau’s report for Friday, October 15th. An arctic air mass originating from northern Canada is advancing southward, accompanied by gusty winds and torrential rainfall. Meteorologists anticipate that temperatures in metropolitan Chicago will plummet to approximately 42 degrees Fahrenheit overnight. Skies will gradually clear by Saturday morning, though the daytime high is projected to peak at a mere 55 degrees. Authorities urge residents across the Great Lakes corridor to brace for potential infrastructural disruptions and hazardous driving conditions. Meanwhile, coastal urban centers such as Boston and New York City will experience intermittent showers through the duration of the weekend. The frontal system is expected to dissipate by late Sunday afternoon, restoring fair weather. Thank you for listening—please remain vigilant and consult local updates for further advisories.</p> -->
        </div>
        <div v-if="currentPhase === 'response'" class="d-flex align-items-center justify-content-center speaking_inner">
          <div class="text-2xl font-semibold" v-if="!isLoading">
            <p>End of the Test</p>
            <p>Your test session is now complete.</p>
          </div>
          <div class="text-2xl font-semibold" v-if="isLoading">
            <p>Loading......</p>
          </div>
        </div>
        <div v-if="currentPhase === 'done'"></div>
      </div>
    </div>
    <!-- buttons -->
    <a class="bg-blue-lighter-toeic text-white p-3 py-2 d-inline-block font-bold text-xl pointer rounded" v-if="selectedStep === 0" @click="start()">START</a>
    <!-- 說明階段 -->
    <a class="bg-blue-lighter-toeic text-white p-3 py-2 d-inline-block font-bold text-xl pointer rounded" v-if="selectedStep === 1 && currentPhase === 'direction'" @click="CONTINUE()">CONTINUE</a>
    <a class="bg-blue-lighter-toeic text-white p-3 py-2 d-inline-block font-bold text-xl pointer rounded" v-if="selectedStep === 1 && currentPhase === 'response'" @click="REPORT()">REPORT</a>
    <!-- 準備階段 -->
    <div class="text-blue-main-toeic" v-if="selectedStep === 1 && currentPhase === 'prepare'">
      <div class="d-flex justify-content-between w-100">
        <div class="d-flex align-items-center">
          <a class="py-2 px-3 bg-white border border-blue-main-toeic pointer font-semibold text-blue-main-toeic">Cut</a>
          <a class="py-2 px-3 bg-white border border-blue-main-toeic pointer font-semibold text-blue-main-toeic">Paste</a>
        </div>
        <div class="d-flex align-items-center">
          <p class="mb-0 py-2 px-3" v-if="!isHideWordCount"><span class="font-semibold">{{ textLength }}</span> words entered</p>
          <a class="py-2 px-3 bg-white border border-blue-main-toeic pointer font-semibold text-blue-main-toeic" @click="isHideWordCount = !isHideWordCount">{{ isHideWordCount ? 'Show': 'Hide' }} Word Count</a>
        </div>
      </div>
      <textarea v-if="answerMap" v-model="inputVal" name="TestingTools" id="" rows="8" class="border rounded w-100 p-2" placeholder="(Type your response here.)"></textarea>
    </div>
  </div>
</template>

<script>
  import Precautions from '@/components/AiHelper/toeic/precautions'
  import Part1 from '@/components/AiHelper/toeic/Part1DescribeImage'
  import Part2 from '@/components/AiHelper/toeic/Part2ReplyEmail'
  import Part3 from '@/components/AiHelper/toeic/Part3OpinionEssay'
  export default {
    name: 'Writing',
    props: {
      writingData: {
        type: Array
      }
    },
    data () {
      return {
        isHideWordCount: false,
        inputVal: null,
        selectedStep: 0,

        currentPhase: 'direction', // 'direction' | 'prepare' | 'response' | 'done'

        isCanActive: false,

        currentPart: 0,
        currentQuestionIndex: 0,
        answerMap: null,
        timer: null,
        remainingTime: 0,

        elapsedTime: 0,
        maxTime: 480,
        timer: null,
        isLoading: false
      }
    },
    components: {
      Precautions,
      Part1,
      Part2,
      Part3
    },
    computed: {
      // formattedTime () {
      //   const m = Math.floor(this.elapsedTime / 60)
      //   const s = this.elapsedTime % 60
      //   return `${this.pad(m)}:${this.pad(s)}`
      // },
      textLength () {
        return this.textVal ? this.textVal.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, '').split(' ').filter(word => word.length > 0).length : 0
      },
      part1Questions () {
        const targetNames = ['描述照片']
        return Array.isArray(this.writingData)
          ? this.writingData.filter(
              el => targetNames.includes(el.Name?.trim())
            )[0]
          : []
      },
      part2Questions () {
        const targetNames = ['回覆書面要求']
        return Array.isArray(this.writingData)
          ? this.writingData.filter(
              el => targetNames.includes(el.Name?.trim())
            )[0]
          : []
      },
      part3Questions () {
        const targetNames = ['陳述意見']
        return Array.isArray(this.writingData)
          ? this.writingData.filter(
              el => targetNames.includes(el.Name?.trim())
            )[0]
          : []
      },
      currentPartQuestions () {
        if (this.currentPart === 0) {
          return this.part1Questions
        } else if (this.currentPart === 1) {
          return this.part2Questions
        } else {
          return this.part3Questions
        }
      },
      isLocked () {
        if (this.currentPart === 0) {
          return false
        } else if (this.currentPart === 1) {
          return true
        } else {
          return true
        }
      }
    },
    mounted () {
      this.answerMap = {
        part1: Array(this.writingData[0].Questions.length).fill(''),
        part2: Array(this.writingData[1].Questions.length).fill(''),
        part3: Array(this.writingData[2].Questions.length).fill('')
      }
    },
    methods: {
      start () {
        this.selectedStep = 1
        if (this.currentPart === 0) {
          this.startPart1()
        } else if (this.currentPart === 1) {
          // this.startPart2()
          // this.startTimer(10 * 60, this.goToNextPart2Question)
        } else {
          // this.startPart3()
          // this.startTimer(30 * 60, this.submitAllAnswers)
        }
      },

      CONTINUE () {
        this.currentPhase = 'prepare'
        if (this.currentPart === 0) {
          // this.startPart1()
        } else if (this.currentPart === 1) {
          this.startPart2()
          this.startTimer(10 * 60, this.goToNextPart2Question)
        } else {
          this.startPart3()
          this.startTimer(30 * 60, this.submitAllAnswers)
        }
      },

      initErsArr () {
        let self = this
        if (self.questionData) {
          let arrLength = self.questionData.Questions.length

          self.ERS_arr = new Array(arrLength).fill({})
        }
      },

      startTimer (maxSeconds, onFinish) {
        this.elapsedTime = 0
        this.maxTime = maxSeconds
        clearInterval(this.timer)

        this.timer = setInterval(() => {
          this.elapsedTime++
          this.$emit('emitTime', this.elapsedTime)
          if (this.elapsedTime >= this.maxTime) {
            clearInterval(this.timer)
            onFinish && onFinish()
          }
        }, 1000)
      },

      stopTimer () {
        this.elapsedTime = 0
        clearInterval(this.timer)
      },
      // === PART 1 ===
      startPart1 () {
        this.currentPart = 0
        this.currentQuestionIndex = 0
        this.startTimer(8 * 60, this.startPart2)
      },
      nextQuestion () {
        if (this.currentQuestionIndex < this.currentPartQuestions.Questions.length - 1) {
          this.currentQuestionIndex++
        }
      },
      nextPart () {
        if (this.currentPart === 0) {
          this.currentPhase = 'direction'
          this.currentPart = 1
          this.currentQuestionIndex = 0
          this.stopTimer()
          this.$emit('emitTime', this.elapsedTime)
        } else if (this.currentPart === 1) {
          this.currentPhase = 'direction'
          this.currentPart = 2
          this.currentQuestionIndex = 0
          this.stopTimer()
          this.$emit('emitTime', this.elapsedTime)
        } else if (this.currentPart === 2) {
          this.currentPhase = 'response'
        }
      },
      prevQuestion () {
        if (this.isLock) return
        if (this.currentQuestionIndex > 0) {
          this.currentQuestionIndex--
        }
      },

      // === PART 2 ===
      startPart2 () {
        this.currentPart = 1
        this.currentQuestionIndex = 0
        // this.startTimer(10 * 60, this.goToNextPart2Question)
      },
      goToNextPart2Question () {
        if (this.currentQuestionIndex === 0) {
          this.currentQuestionIndex = 1
          this.startTimer(10 * 60, this.startPart3)
        }
      },

      // === PART 3 ===
      startPart3 () {
        this.currentPart = 2
        // this.startTimer(30 * 60, this.submitAllAnswers)
      },

      submitAllAnswers () {
        this.stopTimer()
      },
      async REPORT () {
        this.isLoading = true
        await new Promise(resolve => setTimeout(resolve, 1500))
        this.$router.push({ name: 'TOEIC_report', params: { practice_type: 'speaking', record_id: 11111 }})
      }
    }
  }
</script>
<style lang="scss" scoped>
a {
  &:hover {
    text-decoration: none !important;
  }
}
.speaking_inner {
  min-height: calc(60vh);
}
.loading {
  width: 60px;
  height: 60px;
}
.onreconation_icon {
  transform: translate(-50%, -50%);
  animation: move 2s linear infinite;
  transform-origin: center;
}
@keyframes move {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
